export default __webpack_public_path__ + "static/media/free_piece.c548fd05.svg";